export default "__VITE_ASSET__8043546e__"